import React from 'react';
import Button from '../../components/buttons/Button';
import Modal from '../../components/modal.v2/Modal';

import FbPixel from '../fbPixel/FbPixel';

export default class ConfirmacaoBoleto extends React.Component{
  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    const data = {};
    FbPixel.addTrack({event:'Purchase', data:{}});
    FbPixel.addCustomTrack({event:'purchase_boleto_web', data:{}});
  }

  handleSubmit(e){
    e.preventDefault();
    this.props.history.push('/area-restrita/bem-vindo/');
    Modal.destroy();
  }

    render(){
      return(
        <div>
          <div className='box-title'>
            <div className='title-parabens'>Parabéns</div>
            <div className='subtitle-parabens'>Obrigado pela compra! Agora só falta pagar o seu boleto!</div>
          </div>
          <div className=' '>
            <p>Para compras no boleto, são até 72hrs úteis para a confirmação do pagamento (seu boleto foi enviado também para seu e-mail).<br /><br />Após esse período, você receberá, no email no qual você fez a compra, um email com o acesso ao app, em que se encontra todo o programa.<br /><br />Caso não encontre na caixa de entrada, procure no spam/ lico eletrônico do seu email. Se ainda não encontrar, pode ser que tehna digitado seu e-mail errado. Sendo assim, enviei um e-mail para <strong>contato@foco90.com.br</strong>, que a equipe prontamente irá te ajudar.</p><br />
            <p>{/*Este é um PRODUTO DIGITAL, você receberá os dados para acessá-lo via app ou email!<br /><br />*/}
Em caso de dúvidas ou necessidade de suporte relacionado ao produto / serviço, fique à vontade para entrar em contato com nosso suporte através do email <strong>contato@foco90.com.br</strong></p>
<br />
<p>Após confirmado o seu pagamento (em até 3 dias úteis), o link do WhatsApp será enviado para o seu email.</p>
            <br />
            <div className="box-center-button">
              <a
                className='pure-button button-large simples-button button-login blue button-bownload-boleto simple-button'
                target='_blank'
                href={this.props.link}
              >
                Clique aqui e baixe o boleto
              </a>
              <br />
              <br />
              {/*<Button
                text="Acessar meu treino"
                type='button'
                classes="button-login simple-button"
                onClick={this.handleSubmit}
              />*/}
            </div>
            <br /><br />
          </div>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/ConfirmacaoBoleto.js